import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const textareaVariants = tv({
  variants: {
    size: {
      sm: "min-h-18",
      default: "min-h-21",
      lg: "min-h-24"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), textareaCountVariants = tv({
  base: "absolute bottom-2 end-2 text-xs pointer-events-none",
  variants: {
    ariaInvalid: {
      false: "text-(--gray-border-3)",
      true: "text-(--red-9)"
    }
  },
  defaultVariants: {
    ariaInvalid: !1
  }
});
export {
  textareaCountVariants,
  textareaVariants
};
//# sourceMappingURL=index.js.map
